export const onFiltersChanged = "ON_FILTERS_CHANGED";

export default function routineReducer(state, { payload, type }) {
  switch (type) {
    case onFiltersChanged:
      return { ...state, ...payload };
    default:
      return state;
  }
}